<template>
  <div>
    <standard-page title="Permissions" :definition="$t('admin.permissions')">
      <template v-slot:buttons>
        <button class="btn btn-orange rounded font-weight-bold" data-target="#addModal" data-toggle="modal" title="Add Rate">
          <i class="fas fa-plus-square mg-r-10" />Add Permission
        </button>
      </template>
      <template v-slot:content>
        Service: <select v-model="serviceid" aria-controls="service" aria-hidden="true" class="custom-form-control" tabindex="-1">
          <option v-for="service in services" :value="service.service">
            {{ service.name }}
          </option>
        </select>
        <br> <br>
        <data-table :key="serviceid" :api="api" :columns="columns" :rename="renamePermission" list-key="permissions" @ready="onReady" />
      </template>
    </standard-page>

    <delete-modal v-if="permissionIdtoDelete" :service="'accounts'" :dont-show-success-toastr="true" :context="'Permission'" :table="table" :url="`accounts/permissions/${permissionIdtoDelete}`" />

    <div id="addModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Add Permission
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="handleAdd">
            <div class="modal-body">
              <div class="form-group row">
                <div class="col-sm-7">
                  <input id="name" v-model="permission.name" v-validate="'required'" type="text" :class="{'is-invalid': submitted && errors.has('name')}" class="form-control" name="name" data-vv-as="Name" placeholder="Name">
                  <div v-if="submitted && errors.has('name')" class="invalid-feedback">
                    {{ errors.first('name') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Close
              </button>
              <button type="submit" class="btn btn-primary">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/event-bus';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'Permissions',
  data() {
    return {
      tax: {},
      submitted: false,
      rate: {},
      columns: [
        { type: 'name' },
        {
          title: 'Action',
          data: null,
          defaultContent: `
            ${this.$StandardButtons.renameButton('Rename Catalog')}
            ${this.$StandardButtons.deleteButton('#confirmationmodal', 'Delete Catalog')}
          `
        }
      ],
      table: null,
      serviceid: 1,
      permission: {
        name: null
      },
      permissionIdtoDelete: null,
      services: null
    };
  },
  computed: {
    api() { return `${this.$accounts.defaults.baseURL}/accounts/permissions?service_id=${this.serviceid}`; },
  },
  mounted() {
    this.init();
  },

  methods: {
    async init() {
      let result = await this.$accounts.get('accounts/services');
      this.services = result.data.services;
    },
    onReady(table) {
      this.table = table;
      let self = this;

      $(async function () {
        $('#main-table tbody').on('click', '.delete', function () {
          let entity = table.row($(this).parents('tr')).data();
          self.setPermissionIdToDelete(entity.permission);
          table.ajax.reload();
        });

      });

    },

    handleAdd() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          this.addPermission();
        }
      });
    },
    async addPermission() {
      try {
        let permission = {
          service_id: this.serviceid,
          name: this.permission.name,
        };
        await this.$accounts.post('accounts/permissions', permission);
        this.table.ajax.reload();
      } catch (e) {
        this.$showError(e, 'Permission add failed');
      } finally {
        $('#addModal').modal('hide');
      }
    },
    async renamePermission(permission, name) {
      if (name.trim().length > 0) {
        try {
          EventBus.$emit('openLoader');
          await this.$accounts.patch(`accounts/permissions/${permission.permission}`, { name });
        } catch (e) {
          this.$showError(e, 'Permission update failed');
        } finally {
          EventBus.$emit('closeLoader');
          this.table.ajax.reload();
        }
      } else {
        this.$toastr.e('Please provide a name first!', 'Failed');
      }
    },
    setPermissionIdToDelete(permissionId) {
      this.permissionIdtoDelete = permissionId;
    },

  }
}
);
</script>

<style scoped>
</style>
